import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import api from '../../../config/axios';

const ModalSelecionarUnidade = ({ show, onSelectUnidade, user, tempToken, onClose }) => {
  const [unidades, setUnidades] = useState([]);
  const [unidadeSelecionada, setUnidadeSelecionada] = useState('');

  useEffect(() => {
    if (show && user?.unidadesVinculadas) {
      fetchUnidades();
    }
  }, [show, user]);

  const fetchUnidades = () => {
    try {
      const unidadesVinculadas = user.unidadesVinculadas;
      if (Array.isArray(unidadesVinculadas)) {
        const unidadesList = unidadesVinculadas.map(vinculo => vinculo.unidade);
        setUnidades(unidadesList);
        if (unidadesList.length > 0) {
          setUnidadeSelecionada(unidadesList[0].id);
        }
      }
    } catch (error) {
      setUnidades([]);
    }
  };

  const handleConfirm = async () => {
    if (!unidadeSelecionada) {
      Swal.fire('Atenção', 'Por favor, selecione uma unidade para continuar.', 'warning');
      return;
    }

    Swal.fire({
      title: "Carregando...",
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    try {
      const tempAuthToken = tempToken || localStorage.getItem('token');
      
      const response = await api.post('/set-unidade', {
        unidade_id: parseInt(unidadeSelecionada)
      }, {
        headers: {
          'Authorization': `Bearer ${tempAuthToken}`
        }
      });

      if (response.data && response.data.token) {
        localStorage.setItem('user', JSON.stringify(user));
        localStorage.setItem('token', response.data.token);
        
        Swal.close();
        window.dispatchEvent(new Event('storage'));
        
        onSelectUnidade();
      }
    } catch (error) {
      Swal.close();
      Swal.fire('Erro', 'Erro ao selecionar unidade. Tente novamente.', 'error');
    }
  };

  if (!show) return null;

  return (
    <div className="modal fade show" tabIndex="-1" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="fw-bold mt-2">Selecione uma Unidade</h4>
          </div>
          <div className="modal-body">
            <p className="mb-3">Você está vinculado a múltiplas unidades. Selecione uma para continuar:</p>
            
            <div className="row">
              <div className="col-12">
                <label className="form-label fw-bold">Unidade</label>
                <select 
                  className="form-select" 
                  value={unidadeSelecionada} 
                  onChange={(e) => setUnidadeSelecionada(e.target.value)}
                >
                  {unidades.map(unidade => (
                    <option key={unidade.id} value={unidade.id}>
                      {unidade.nome}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-custom-primary"
              onClick={handleConfirm}
              disabled={!unidadeSelecionada}
            >
              Continuar
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalSelecionarUnidade;